import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import { Select } from "../components/select/Select";
import type { CustomerContactPerson } from "../customers/customersApi";
import type { SavedOrder } from "../orders/orderTypes";

export interface CustomerContactData {
  contacts: CustomerContactPerson[];
  selected?: CustomerContactPerson;
}

const NO_DATA = "Brak";

export function CustomerContactDialog(props: {
  data: CustomerContactData;
  onUpdate(contactPersonEmail: string): Promise<SavedOrder>;
  onClose(): void;
}) {
  const data = props.data;
  const [selected, setSelected] = useState(data.selected?.loginEmail ?? NO_DATA);
  const hasChanged = selected != data.selected?.loginEmail && selected != NO_DATA;
  const onSave = async () => {
    await props.onUpdate(selected);
    props.onClose();
  };
  return (
    <Dialog open={true} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <InfoOutlinedIcon color="primary" />
        Edytuj koordynatora wyjazdu
      </DialogTitle>
      <DialogContent
        sx={{
          pt: 2,
          overflow: "visible",
        }}
      >
        <Select
          label="koordynator wyjazdu"
          fullWidth
          value={selected}
          values={data.contacts.map((v) => ({
            value: v.loginEmail ?? "",
            label: v.name ?? "",
          }))}
          onSelect={(v) => setSelected(v)}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={!hasChanged} onClick={onSave}>
          Zapisz
        </Button>
        <Button onClick={props.onClose}>Zamknij</Button>
      </DialogActions>
    </Dialog>
  );
}
